/**
 * Copyright 2025 Design Barn Inc.
 */

/* eslint-disable react-perf/jsx-no-new-object-as-prop */

import { IconWarningOutline } from '@lottiefiles/icons';
import { lottiefilesLightToken } from '@lottiefiles/tokens';
import Link from 'next/link';
import React from 'react';

import { extractLinkInfo, stripHtmlTags } from '../../utils/error-messages';

export default function NotificationBanner({ label }: { label: string }): React.ReactElement {
  const htmlLinkContent = extractLinkInfo(label);

  let errorTextComponent = <p className="text-sm">{stripHtmlTags(label)}</p>;

  if (htmlLinkContent) {
    errorTextComponent = (
      <p className="text-sm">
        {stripHtmlTags(label)}
        <Link href={htmlLinkContent.href} className="text-action-primary hover:text-action-primary-hover" target="_parent">
          {htmlLinkContent.text}
        </Link>
      </p>
    );
  }

  return (
    <div className="mb-5 flex rounded-sm bg-red-50 py-3 px-3 items-center">
      <IconWarningOutline className="mr-4" style={{ width: 28, height: 28 }} color={lottiefilesLightToken.color.actionCritical}/>
      {errorTextComponent}
    </div>
  );
}
